import React, { useState } from "react";
import Heading from "./Pages/Heading";
import Home from "./Pages/Home";
import Things from "./Pages/Things";

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Heading />
      {
        currentPage === 'home' ? (
          <Home onExplore={() => setCurrentPage('things')} />
        ) : (
          <Things onBack={() => setCurrentPage('home')} />
        )
      }
    </>

  );
}

export default App;
